module.exports = __webpack_public_path__ + "static/media/AlbanyAdvertiser-devicecomp-min@2x.0c2403bd.png";